import React from "react";


const BlogCard = () => {
  // Static data
  const image =
     
    "https://bonviesnacks.com/cdn/shop/articles/Frame_77.png?v=1747919463&width=1100";
  const date = "May 20, 2025";
  const title =
    "7 Easy Recipes Using Freeze-Dried Fruits (Smoothies, Bakes, Bowls)";
  const description =
    "Make smoothies, bakes, and bowls healthier and tastier with Bonvie’s freeze-dried fruits. Try 7 easy...";

  const link = "#";

  return (
    <div className="max-w-md mx-auto bg-white">
      {/* Image */}
      <div className="rounded-2xl overflow-hidden">
        <img src={image} alt={title} className="w-full h-auto object-cover" />
      </div>

      {/* Date */}
      <p className="text-gray-700 text-sm mt-3">{date}</p>

      {/* Title */}
      <h3 className="text-lg md:text-xl font-bold mt-1">
        {title}
      </h3>

      {/* Description */}
      <p className="text-gray-600 mt-2">
        {description}
      </p>

      {/* Learn more */}
      <a
        href={link}
        className="inline-block mt-3 text-black font-medium border-b border-black hover:text-gray-700"
      >
        Learn More
      </a>
    </div>
  );
};

export default BlogCard;
